import script from "./AnnahmecheckLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnahmecheckLoader.vue?vue&type=script&setup=true&lang=js"

import "./AnnahmecheckLoader.vue?vue&type=style&index=0&id=9e2df06e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e2df06e"]])

export default __exports__